import { useEffect, useRef } from 'react'

/** @jsxImportSource @emotion/react */
import type { css } from '@emotion/react'

import { container } from './dynamic-content.styles'

type DynamicContentProps = {
  content?: string
  styles?: ReturnType<typeof css>
}

export const DynamicContent = ({ content, styles }: DynamicContentProps) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.querySelectorAll('ol[start]').forEach((ol) => {
        ol.setAttribute('style', `--start:${ol.getAttribute('start')}`)
      })
    }
  }, [])

  return (
    <div
      dangerouslySetInnerHTML={{ __html: content ?? '' }}
      ref={ref}
      css={[container, styles]}
    />
  )
}
